import { css } from '@linaria/core';
import { baseTheme, baseUnits, breakpoints, flex } from 'styles/utils';
export const predictionTitle = "odules__Predictions__components__PredictionSidebar__PredictionSidebar_styles_ts-predictionTitle-pn1c2sz";
export const predictionListWrapper = `${"odules__Predictions__components__PredictionSidebar__PredictionSidebar_styles_ts-predictionListWrapper-p1ct6dw3"}
  ${flex.init}
  ${flex.flex.auto}
  ${flex.direction.column}
  ${flex.alignItems.start}
`;
export const sidebar = "odules__Predictions__components__PredictionSidebar__PredictionSidebar_styles_ts-sidebar-s1e7zdsr";
export const settings = "odules__Predictions__components__PredictionSidebar__PredictionSidebar_styles_ts-settings-s1o54kc1";
export const InputActionButton = "odules__Predictions__components__PredictionSidebar__PredictionSidebar_styles_ts-InputActionButton-imnw1cp";
export const InputActionTooltip = "odules__Predictions__components__PredictionSidebar__PredictionSidebar_styles_ts-InputActionTooltip-i1r7p2q1";

require("./PredictionSidebar.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PredictionSidebar.styles.ts");